import React from 'react';
import TileDivider from './TileDivider';

const Hero = () => {
  return (
    <div className="text-center flex flex-col items-center">
      <div className="mb-10 md:mb-12">
        <img 
          src="https://media-manager-c.questera.ai/greta-media/8c3dc8994f71a85ad2d71f226c89cc7edce114857865647a461869cb9a6c120ffe2f6c628544606d61dcf48135de6ac8/images/aW1hZ2UvcG5n/982cd76f140479f64830f15898823d30.png" 
          alt="Padua Weddings Logo" 
          className="w-[150px] md:w-[200px] h-auto object-contain"
        />
      </div>

      <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-padua-dark mb-6 leading-tight">
        Share Your <br className="hidden sm:block" />
        <span className="italic text-padua-olive">Padua Experience</span>
      </h2>

      <TileDivider className="my-8" />

      <p className="text-lg md:text-xl text-padua-dark/80 font-light max-w-2xl mx-auto leading-relaxed mb-10">
        Your kind words help future couples feel confident choosing Padua for one of the most meaningful days of their lives.
      </p>

      <div className="bg-white/60 backdrop-blur-sm border border-padua-gold/20 rounded-2xl p-6 md:p-8 max-w-xl mx-auto mb-4">
        <h4 className="font-serif text-xl text-padua-dark mb-3">Not sure what to say? We made it easier.</h4>
        <p className="text-sm md:text-base text-padua-dark/70 font-light leading-relaxed">
          Whether you celebrated your wedding here, attended as a guest, worked with us as a vendor, or joined us for an event, a few honest words can help future couples feel confident choosing Padua.
        </p>
      </div>
    </div>
  );
};

export default Hero;